<template>
    <div class="card" style="min-height: 450px;">
        <h6 class="card-header" style="color:#348cd4;" > List of Beneficiaries</h6>

        <vue-bootstrap4-table
            :rows="rows"
            :columns="columns"
            :config="config">

            <template slot="id" slot-scope="props">
                <span>
                    {{props.row.vbt_id}}
                </span>
            </template>
            
            <template slot="accountStatus" slot-scope="props">
                <span v-if="props.cell_value == 1">
                    Active
                </span>
                <span v-else>
                    In active
                </span>
            </template>

            <template slot="action" slot-scope="props">
                <button type="button" title="view profile" class="btn btn-primary btn-sm">
                    <router-link :to="'/viewprofile/'+props.cell_value" class="text-white text-decoration-none">
                        <!-- <v-icon name="eye" style="width:14px"></v-icon> -->
                        View Profile
                    </router-link>
                </button>       
            </template>

            <template slot="sort-asc-icon">
                <i class="fas fa-sort-up"></i>
            </template>
            <template slot="sort-desc-icon">
                <i class="fas fa-sort-down"></i>
            </template>
            <template slot="no-sort-icon">
                <i class="fas fa-sort"></i>
            </template>
        </vue-bootstrap4-table>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import VueBootstrap4Table from 'vue-bootstrap4-table';

export default {
    name: "ListBeneficiary",
    components:{
        VueBootstrap4Table
    },
    data(){
        return {
            rows: [],
            columns: [
                {
                    label: "S/N",
                    name: "id",
                    slot_name: "id"
                },
                {
                    label: "Beneficiary ID",
                    name: "beneficiaryId",
                    sort: true,
                },
                {
                    label: "Beneficiary Name",
                    name: "name",
                    sort: true,
                },
                {
                    label: "Beneficiary Email",
                    name: "email",
                    sort: true,
                },
                {
                    label: "Beneficiary Phone",
                    name: "phone",
                    sort: true,
                },
                {
                    label: "Account Status",
                    name: "accountStatus",
                    slot_name: "accountStatus",
                    sort: true,
                },
                {
                    label: "Action",
                    name: "beneficiaryId",
                    slot_name: "action",
                    sort: true,
                },
                
            ],
            config: {
                card_mode: false,
                show_refresh_button: false,
                show_reset_button: false,
                checkbox_rows: false,
                rows_selectable: false,
                selected_rows_info: false,
                global_search: {
                    placeholder: "Search Beneficiary",
                    visibility: false,
                    case_sensitive: false,
                },
            }
        }
    },
    computed:{
        ...mapState(['token'])
    },
    mounted(){
        this.getBeneficiaryList()
    },
    methods:{
        getBeneficiaryList(){
            this.$toastr.removeByType("error"); // remove all error type message

            const baseU = `${this.$urlAuth}/beneficiary/getall`;

            this.$http.get(baseU,{
                headers:{
                    "x-access-token":this.token
                }
            })
            .then(response => {
                if(response.data.data.code =='S200'){
                    this.rows = response.data.data.beneficiaries;

                }else{
                    this.$toastr.e(response.data.data.message);
                    this.rows = [];
                }
            })
            .catch(err => {
                console.log(err);
                if(err.message == "Network Error"){
                    this.$toastr.e("Network Error, check internet connection");
                    return;
                }
                this.$toastr.e("Internal Server error");
            })
        },
    }
}
</script>
